import React, { useEffect, useState } from 'react'
import { HeaderStyle } from './Header.style'
import { useNavigate } from 'react-router-dom';
import home from "../../Assets/8541853_home_icon.svg"

function Header() {
  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('user')) {
        setLoggedIn(true)
    }

    let interval = setInterval(() => {
      if (sessionStorage.getItem('user')) {
        setLoggedIn(true)
        clearInterval(interval)
    }
    }, 500);
}, []);
useEffect(() => {
let interval = setInterval(() => {
    if (sessionStorage.getItem('user')) {
      setLoggedIn(true)
      clearInterval(interval)
  }
  }, 500);
}, [loggedIn]);
console.log(JSON.parse(sessionStorage.getItem('user')));
  return (
   loggedIn ? <HeaderStyle>
    
            <h1 onClick={() => {
              if (JSON.parse(sessionStorage.getItem('user')).cvr) {
                navigate(`/clientpage/${JSON.parse(sessionStorage.getItem('user')).id}`)
              }else{
                navigate('/dashboard')
              }
              }}>AgroAPV</h1>
              <button className='mobileShow' onClick={() => {
              sessionStorage.removeItem('user')
              setLoggedIn(false)
              navigate('/')
              }}>log ud</button>
            <p className='mobileHide'>{loggedIn ? "logget ind som: " + JSON.parse(sessionStorage.getItem('user'))?.firstname : ""} </p>
            <img className='mobileHide' src={home} alt="home" onClick={() => {
              if (JSON.parse(sessionStorage.getItem('user')).cvr) {
                navigate(`/clientpage/${JSON.parse(sessionStorage.getItem('user')).id}`)
              }else{
                navigate('/dashboard')
              }
              }} />
            <button className='mobileHide' onClick={() => {
              sessionStorage.removeItem('user')
              setLoggedIn(false)
              navigate('/')
              }}>log ud</button>
    </HeaderStyle> : null

  )
}

export default Header